import "date-fns";
import React, { Fragment, useState, useContext } from "react";

import { makeStyles } from "@material-ui/core/styles";
import Alert from "@material-ui/lab/Alert";
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import Grid from "@material-ui/core/Grid";
import axios from "axios";
import { UrlServicesContext } from "../../components/UrlServicesContext";
import { Typography } from "@material-ui/core";


const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

const useStyles = makeStyles((theme) => ({
  alert_background: {
    color: "#F7F00B",
    background: "#000",
    boxShadow:
      "0 4px 20px 0 rgba(0, 0, 0,.14), 0 7px 10px -5px rgba(0, 0, 0,.4)",
  },
  containerForm: {
    padding: "3%",
  },
  buttonSubmit: {
    marginTop: "6%",
    color: "#000",
    background: "#F7F00B",
    boxShadow:
      "0 4px 20px 0 rgba(0, 0, 0,.14), 0 7px 10px -5px rgba(0, 0, 0,.4)",
    "&:hover": {
      backgroundColor: "#000",
      color: "#F7F00B",
    },
  },
  input: {
    borderBottom: "1.2px solid #000",
    marginTop: "10px",
    padding: "5px 0 6px",
  },
}));

export default function DeleteProduct(props) {
  const classes = useStyles();
  const [error, setError] = useState(false);
  const [mensaje_error, setMensaje_error] = useState("");
  const [openAlertSuccess, setOpenAlertSuccess] = useState(false);
  const [mensaje_success, setMensaje_success] = useState("");

  const { urlServices } = useContext(UrlServicesContext);

  const handleCloseDialog = (pro) => (event) => {
    props.exit();
  };

  const handleChangeDelete = (event) => {
    const data = new FormData();
    data.append("id", props.id);

    axios
        .post(urlServices + "routes.php?servicio=eliminarProducto", data)
        .then(
          (response) => {
            if (response.data.code === 0) {
                props.callBackRefresh(true)
                setOpenAlertSuccess(true)
                setMensaje_success('Eliminado con Éxito.');
            }else{
              setError(true);
              setMensaje_error('Error al eliminar');
            }
          },
          (error) => {
            setError(true);
            setMensaje_error('Error al eliminar');
          }
        );
  }; 

  return (
    <Fragment>
      <Dialog
        fullWidth
        maxWidth="sm"
        onClose={handleCloseDialog(true)}
        aria-labelledby="customized-dialog-title"
        open={props.open}
      >
        <Alert
          severity="info"
          elevation={6}
          variant="filled"
          className={classes.alert_background}
        ></Alert>
        <DialogContent dividers>          
         
              <form  noValidate autoComplete="off">
                <Grid container spacing={2} className={classes.containerForm}>
                  <Grid item xs={12} md={12}>
                  <center>
                  <Typography align="center" variant="h6" color="secondary"> ¿Desea eliminar este producto? </Typography>

              <Button
                variant="contained"
                color="default"
                className={classes.buttonSubmit}
                onClick={handleChangeDelete}
              >
                Eliminar
              </Button>
            </center>
                  </Grid>
                </Grid>
                <br></br>
                <center>
                  {error ? <Alert severity="error">{mensaje_error}</Alert> : ""}
                  {openAlertSuccess ? (
                    <Alert severity="success">{mensaje_success}</Alert>
                  ): ""}
                </center>
              </form>         
         
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleCloseDialog(true)}
            variant="contained"
            size="medium"
          >
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>     
    </Fragment>
  );
}
